import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-examples-landing',
  templateUrl: './examples-landing.component.html',
  styleUrls: ['./examples-landing.component.css']
})
export class ExamplesLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
